import * as types from './action-types'

export const fetchWorkerDuplicateAccountsCount = (workerID: number) => ({
  type: types.WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_BEGIN,
  workerID,
})
